import scrollIntoView from 'scroll-into-view-if-needed';

const scrollToElement = (element, block = 'start', scrollMode = 'always') => {
  if (!element) {
    return;
  }

  scrollIntoView(element, {
    block,
    scrollMode,
    behavior: 'smooth',
  });
};

export { scrollToElement };
